<ng-container [ngSwitch]="item?.ItemType">
  <fgbcl-auction-won-list-item
    *ngSwitchCase="itemType?.Auction"
    [auctionItem]="auctionItem"
    [showButton]="showButton"
    [orientation]="orientation"
  ></fgbcl-auction-won-list-item>
  <fgbcl-marketplace-purchased-list-item
    *ngSwitchCase="itemType?.Marketplace"
    [purchaseItem]="marketplaceItem"
    [multi]="multi"
    [showButton]="showButton"
    [orientation]="orientation"
  ></fgbcl-marketplace-purchased-list-item>
  <fgbcl-lottos-won-list-item
    *ngSwitchCase="itemType?.Lotto"
    [lottoItem]="item"
    [multi]="multi"
    [showButton]="showButton"
    [orientation]="orientation"
  ></fgbcl-lottos-won-list-item>
</ng-container>
